const config = {
        app: {
            name: "Live Cricket Kerala",
            short_name: "Live Cricket Kerala",
            website: "4cr.in",
            backend_api_url: process.env.REACT_APP_BACKEND_API_URL || "http://localhost:8074/4cr_in/index.php/",
            backend_api_url9: "https://musheertm.4cr.in/api/index.php/",
            backend_api_url8: "https://testing.4cr.in/api/index.php/",
            backend_api_url4: "https://4cr.in/api/index.php/",
            ga_code: process.env.REACT_APP_GA_CODE || "G-1TVVV50CP6"
        }
};

// Make it available globally
global.config = config;

export default config;